import { Button, type ButtonProps, Tooltip } from 'antd';
import React from 'react';
import { useHref, useNavigate, useSearchParams } from 'react-router';

import { getLinkLocation } from './link';

function LinkButton({
  to,
  label,
  icon,
  type = 'default',
  openInNewTab = false,
  isIconOnly = false,
}: {
  to: string;
  label: string;
  icon: React.ReactNode;
  type?: ButtonProps['type'];
  openInNewTab?: boolean;
  isIconOnly?: boolean;
}): React.ReactElement {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = getLinkLocation(to, searchParams);
  const href = useHref(location);

  const button: React.ReactElement = (
    <Button
      type={type}
      href={href}
      target={openInNewTab ? '_blank' : undefined}
      rel={openInNewTab ? 'noopener noreferrer nofollow' : undefined}
      aria-label={isIconOnly ? label : undefined}
      icon={icon}
      onClick={(event: React.MouseEvent<HTMLElement>): void => {
        if (openInNewTab || event.metaKey || event.ctrlKey) {
          return;
        }

        event.preventDefault();
        navigate(location);
      }}
    >
      {isIconOnly ? null : label}
    </Button>
  );

  if (!isIconOnly) {
    return button;
  }

  return <Tooltip title={label}>{button}</Tooltip>;
}

export default LinkButton;
